import { cn } from "../../lib/utils";

function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn("ui-motion-skeleton bg-glass-bg", className)}
      {...props}
    />
  );
}

export { Skeleton };
